import { toKm } from "@leafly-com/web-utils";

export const convertToKilometers = (
  miles?: string | number | null,
): string | null => toKm(miles)?.toFixed(1);
